import { usePeopleManagementApi } from 'infrastructure/api';
import { useBaseCrudService } from 'framework/crud';
import { storageService } from 'framework/utils';

export type EmployeeSkillsNamesType = {
  createdAt: string;
  id: string;
  name: string;
  updatedAt: Nullable<string>;
};

const useEmployeeSkillsNamesService = () => {
  const { searchAll } = useBaseCrudService({
    listResourceUrl: '/skills',
    singleResourceUrl: '',
    useService: usePeopleManagementApi,
  });

  const { getDataFromStorage } = storageService('employeeSkills', searchAll, '3.0');

  return {
    searchAll: getDataFromStorage,
  };
};

export default useEmployeeSkillsNamesService;
